export enum SocialSecurityBenefitType {
  Retirement = 'Retirement',
  Disability = 'Disability',
}
